import http from './http';

export default {
  all() {
    return http().get(`/v1/campaign_unit_counts`);
  },
  get(id) {
    return http().get(`/v1/campaign_unit_counts/${id}`);
  },
  create(data) {
    return http().post(`/v1/campaign_unit_counts`, data);
  },
  update(data) {
    return http().put(`/v1/campaign_unit_counts/${data.id}`, data);
  },
  delete(id) {
    return http().delete(`/v1/campaign_unit_counts/${id}`);
  },
}
